import client from '@/base-http'
import { ProductPagination, ProductPaginationParams, Product } from '@/modules/product'
import UnigestLanguage from '@/modules/product/model/UnigestLanguage';

/**
 * Obtiene una paginación de productos de Unigest
 *
 * @param page Número de página a obtener
 * @param recordsPerPage Registros por página a obtener
 * @param filters Filtros de búsqueda
 */
export async function getProductPagination (params: ProductPaginationParams) {
    const response = await client.get('unigest/products', {
        params: {
            page: params.page,
            recordsPerPage: params.recordsPerPage,
            ...params.filters || {},
        },
    })

    return ProductPagination.deserialize(response.data)
}

/**
 * Obtiene un producto registro en Unigest en base a su identificador
 *
 * @param id
 */
export async function getProduct (id: string) {
    const response = await client.get(`shop/products/${id}`)

    return Product.deserialize(response.data)
}

/**
 * Permite obtener la imagen a tamaño completo de un producto
 *
 * @param id
 */
export async function getProductImage (id: string) {
    const response = await client.get(`unigest/products/${id}/image`)

    return response.data.data
}

/**
 * Sube una imagen al servidor
 *
 * @param id
 * @param data
 */
export async function uploadProductImage (id: string, data: string) {
    const response = await client.post(`unigest/products/${id}/image`, {data})

    return response.data.success || false
}


/**
 * Actualiza un producto de la tienda
 *
 * @param product
 */
export async function updateProduct (product: Product) {
    const data = product.serialize()
    const response = await client.put(`shop/products/${product.id}`, {data})

    return Product.deserialize(response.data)
}

/**
 * Obtiene la lista de idiomas registrados en Unigest
 */
export async function getUnigestLanguages () {
    const data = (await client.get('unigest/languages')).data
    if (!Array.isArray(data)) {
        throw new Error('Se esperaba un array con la lista de idiomas')
    }

    return data.map(l => UnigestLanguage.deserialize(l))
}
